import { IMultiLiveIcon1Props } from "interfaces";
import { conditions } from "../../../../helpers/conditions/conditions";
import { ConditionName } from "../../../../interfaces/enums";

const MultiLivesIcon = ({ className, width, height, strokeColor, onClick }: IMultiLiveIcon1Props) => {
    return (
        <>
            {conditions(ConditionName.isComplexPortrait) ? (
                <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} width={width} height={height}>
                    <path d="M11.332 15.167H4.66536C2.23203 15.167 0.832031 13.767 0.832031 11.3337V8.00033C0.832031 5.56699 2.23203 4.16699 4.66536 4.16699H11.332C13.7654 4.16699 15.1654 5.56699 15.1654 8.00033V11.3337C15.1654 13.767 13.7654 15.167 11.332 15.167ZM4.66536 5.16699C2.7587 5.16699 1.83203 6.09366 1.83203 8.00033V11.3337C1.83203 13.2403 2.7587 14.167 4.66536 14.167H11.332C13.2387 14.167 14.1654 13.2403 14.1654 11.3337V8.00033C14.1654 6.09366 13.2387 5.16699 11.332 5.16699H4.66536Z" />
                    <path d="M12 3.5H4C3.72667 3.5 3.5 3.27333 3.5 3C3.5 2.72667 3.72667 2.5 4 2.5H12C12.2733 2.5 12.5 2.72667 12.5 3C12.5 3.27333 12.2733 3.5 12 3.5Z" />
                    <path d="M10 1.83301H6C5.72667 1.83301 5.5 1.60634 5.5 1.33301C5.5 1.05967 5.72667 0.833008 6 0.833008H10C10.2733 0.833008 10.5 1.05967 10.5 1.33301C10.5 1.60634 10.2733 1.83301 10 1.83301Z" />
                    <path
                        d="M6.43109 8.56822C6.43109 8.06804 6.97255 7.75543 7.40571 8.00552L9.50646 9.21839C9.93963 9.46848 9.93963 10.0937 9.50646 10.3438L7.40571 11.5567C6.97255 11.8067 6.43109 11.4941 6.43109 10.994L6.43109 8.56822Z"
                        stroke-width="0.8"
                    />
                </svg>
            ) : (
                <svg
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    width={width}
                    height={height}
                    onClick={onClick}
                >
                    <path
                        d="M15.582 20.854H6.41536C3.06953 20.854 1.14453 18.929 1.14453 15.5832V10.9998C1.14453 7.654 3.06953 5.729 6.41536 5.729H15.582C18.9279 5.729 20.8529 7.654 20.8529 10.9998V15.5832C20.8529 18.929 18.9279 20.854 15.582 20.854ZM9.6237 10.9998C8.2487 11.4582 9.16537 13.8782 9.16537 16.4998L6.8737 16.9582C6.8737 19.5798 4.25203 16.4998 6.8737 16.4998L10.5404 15.5832L13.2904 13.7498L15.582 11.9165C18.2037 11.9165 18.332 14.2082 19.707 14.2082L14.207 17.8748C14.207 15.2532 17.7454 14.2082 15.1237 14.2082L9.6237 10.9998Z"
                        fill="white"
                    />
                    <path
                        d="M16.5 4.8125H5.5C5.12417 4.8125 4.8125 4.50083 4.8125 4.125C4.8125 3.74917 5.12417 3.4375 5.5 3.4375H16.5C16.8758 3.4375 17.1875 3.74917 17.1875 4.125C17.1875 4.50083 16.8758 4.8125 16.5 4.8125Z"
                        fill="white"
                    />
                    <path
                        d="M13.75 2.521H8.25C7.87417 2.521 7.5625 2.20933 7.5625 1.8335C7.5625 1.45766 7.87417 1.146 8.25 1.146H13.75C14.1258 1.146 14.4375 1.45766 14.4375 1.8335C14.4375 2.20933 14.1258 2.521 13.75 2.521Z"
                        fill="white"
                    />
                    <path
                        d="M8.99497 11.5003C8.99497 11.0552 9.47684 10.7769 9.86233 10.9995L13.2347 12.9465C13.6202 13.1691 13.6202 13.7255 13.2347 13.9481L9.86233 15.8951C9.47684 16.1177 8.99497 15.8395 8.99497 15.3943L8.99497 11.5003Z"
                        stroke={strokeColor}
                        stroke-width="0.4"
                    />
                </svg>
            )}
        </>
    );
};

export default MultiLivesIcon;
